import { render, staticRenderFns } from "./previousFormSubs.vue?vue&type=template&id=59c5f2b0&scoped=true"
import script from "./previousFormSubs.vue?vue&type=script&lang=js"
export * from "./previousFormSubs.vue?vue&type=script&lang=js"
import style0 from "./previousFormSubs.vue?vue&type=style&index=0&id=59c5f2b0&prod&lang=css"
import style1 from "./previousFormSubs.vue?vue&type=style&index=1&id=59c5f2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5f2b0",
  null
  
)

export default component.exports